import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { Loading, StaticMap } from "web/components"
import { render } from "react-dom"
import React, { Suspense } from "react"
import routes from "web/routes/constants"

export default class StaticMapController extends Controller {
  static values = {
    locations: Array,
    centerAssetId: Number,
    viewGroupSlug: String,
    viewId: Number,
    assetsMapViewCenterUrl: String,
  }

  initialize() {
    this.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <StaticMap
            locations={[{ locations: this.locationsValue }]}
            lngLatFn={this.lngLatFn}
            onLocationClick={this.handleLocationClick.bind(this)}
          />
        </Router>
      </Suspense>,
      this.element
    )
  }

  lngLatFn(x) {
    return [x.locations[0].longitude, x.locations[0].latitude]
  }

  handleLocationClick() {
    if (this.hasAssetsMapViewCenterUrlValue) {
      window.Turbo.visit(this.assetsMapViewCenterUrlValue)
      return
    }

    const viewId = this.hasViewIdValue ? this.viewIdValue : null

    window.Turbo.visit(
      routes.assetsMap(this.viewGroupSlugValue, viewId, {
        center_on: this.centerAssetIdValue,
      })
    )
  }
}
